import { Component, HostListener, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'piqet-angular-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  showScroll = false;
  showScrollHeight = 100;
  hideScrollHeight = 5;
  isDashboard!: boolean;
  urlChecker!: Subscription;
  currentYear: any;
  appVersion: string = '';
  constructor(private router: Router, private meta: Meta) {}

  ngOnInit() {
    const date = new Date();
    // Prefer the CI-stamped build version (tools/stamp-version.js); fall back to the
    // app-version meta tag, then a static label for local/unstamped builds.
    const buildVersion = this.meta.getTag('name="build-version"')?.content;
    const appVersion = this.meta.getTag('name="app-version"')?.content;
    this.appVersion =
      buildVersion && buildVersion !== 'local-dev'
        ? `Build: ${buildVersion}`
        : appVersion
        ? `Version: ${appVersion}`
        : 'Release: v5';
    this.currentYear = date.getFullYear();
    this.urlChecker = this.router?.events.subscribe((event: any) => {
      this.isDashboard = event?.routerEvent?.url?.includes('/dashboard');
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >
      this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) <
        this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  ngOnDestroy() {
    this.urlChecker.unsubscribe();
  }
}
